const log = (message) => {
  // eslint-disable-next-line
  console.log(`Sending to elastic console : ${message}`)
}

export default log
